import { apiService } from './api'
import type { CreateHealthData, UpdateHealthData } from '@/types'

class HealthService {
  async getHealth(params?: any) {
    const response = await apiService.api.get('/admin/health', { params })
    return response.data
  }

  async getAllHealth() {
    const response = await apiService.api.get('/admin/health/all')
    return response.data
  }

  async getHealthItem(id: string | number) {
    const response = await apiService.api.get(`/admin/health/${id}`)
    return response.data
  }

  async createHealth(data: CreateHealthData) {
    const response = await apiService.api.post('/admin/health', data)
    return response.data
  }

  async updateHealth(id: string | number, data: UpdateHealthData) {
    const response = await apiService.api.put(`/admin/health/${id}`, data)
    return response.data
  }

  async deleteHealth(id: string | number) {
    await apiService.api.delete(`/admin/health/${id}`)
  }

  async getHealthStats() {
    const response = await apiService.api.get('/admin/health/stats')
    return response.data
  }
}

export const healthService = new HealthService()